import GitHub from "../assets/menu/github.svg"; 
import LinkedIn from "../assets/menu/linkedin.svg"; 
import At from "../assets/menu/at.svg"; 

export const menuSocials = [
    {
        id: 1, 
        url: "https://www.github.com/danveb", 
        target: "_blank", 
        rel: "noreferrer noopener", 
        img: GitHub, 
        alt: "social icon",
    },
    {
        id: 2, 
        url: "https://www.linkedin.com/in/daniel-eze-bae", 
        target: "_blank", 
        rel: "noreferrer noopener", 
        img: LinkedIn, 
        alt: "social icon",
    },
    {
        id: 3, 
        url: "mailto:danibae91@gmail.com", 
        target: "_blank", 
        rel: "noreferrer noopener", 
        img: At, 
        alt: "social icon",
    },
]; 